import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App";
import { HashRouter } from "react-router-dom";
import ReactGA from "react-ga4";

//  "test": "GENERATE_SOURCEMAP=false env-cmd -f .env.test react-scripts build",
ReactGA.initialize("G-3K003HCL9N",{gtagUrl:'https://edos.apollodiagnostics.in'});

// Send pageview with a custom path
ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Custom Title" });


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </HashRouter>
  </React.StrictMode>
);
